import { defineComponent as _defineComponent } from 'vue';
import { useFrameStore } from './seg-frame-store';
import { RAW_COSTS_CONFIG } from './helpers/frameConstants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CostSettingsTable',
    setup(__props, { expose: __expose }) {
        __expose();
        const store = useFrameStore();
        const __returned__ = { store, get RAW_COSTS_CONFIG() { return RAW_COSTS_CONFIG; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
